<div class="d-grid gap-2">
        <button data-bs-toggle="tooltip" data-placement="top" type="button" title="Zurück" id="back-button" (click)="navigateBack()" class="button p-1 ps-2 pe-2" i18n-title i18n>
                <i class="fa-solid fa-angle-left"></i>&nbsp;&nbsp;Zurück
        </button>
</div>